import React from 'react';
import { translate } from 'react-i18next';
import {Bar} from 'react-chartjs-2';
import moment from 'moment';
import numbro from 'numbro';
import { Icon, Segment, Header, Button, Container, Grid, Message, Input } from 'semantic-ui-react';

import Ring from 'modules/misc/Ring.js';
import LoadInline from 'modules/loading/LoadInline.js';
import Utils from 'utils/Utils.js';
import {colors, fontSizes, fonts, shadow, shadowLight, spacings, layout, buttons} from 'style';
import StepsChallengeModal from './StepsChallengeModal.js';

var style= {
    container: {
        maxWidth: layout.screenWidth,
        marginLeft: 'auto',
        marginRight: 'auto',
        minHeight: '100%',
    },
    content: {
        height:'100%', 
        margin: '0px',
        textAlign: 'center',
    },
    segment: {
        backgroundColor: 'white',
        borderRadius: '9px',
        boxShadow: shadowLight,
        margin: spacings.small,
        padding: spacings.base,
        textAlign: 'center',
        height: '466px',
    },
    grid: {
        ...fonts.body,
        lineHeight: '1.5',
        color: colors.themeBlue,
    },
    ring:{
        width:"100%",
        height:"100%", 
        position: 'absolute'
    },
    body: {
        position: 'relative',
        display: 'inline-block',
        height: '240px',
        width: '240px',
        marginTop: spacings.small,
    },
    ringContent: {
        position: 'absolute',
        width: '220px',
        height: '220px',
        top: '50%',
        left: '50%',
        marginTop: '-110px',
        marginLeft: '-110px',
        paddingTop: spacings.base,
    },
    stepIcon: {
        fontSize: '50px',
        color: colors.themeBlue,
    },
    todayValue: {
        paddingTop: '0',
        fontSize: fontSizes.h2,
    },
    denominator: {
        fontSize: fontSizes.bodyL,
    },
    points: {
        marginLeft: spacings.tiny,
        color: colors.pointsYellow,
    },
    addSteps: {
        color: colors.themeBlue,
        position: 'absolute',
        bottom: spacings.tiny,
        left: spacings.tiny,
        fontSize: fontSizes.body,
        margin: spacings.base,
        cursor: 'pointer',
    },
    addIcon: {
        marginLeft: spacings.tiny,
    },
    message: {
        fontWeight: 'normal',
        ...fonts.body,
        lineHeight: '1',
        borderRadius: '100px',
        backgroundColor: colors.themeBlue,
        color: '#fff',
        width: '100%',
        maxWidth: '160px',
        marginLeft: 'auto',
        marginRight: 'auto',
        boxShadow: 'none',
        marginBottom: spacings.base,
        padding: '.78571429em 1.5em .78571429em',
    },
    inputWrapper: {
        padding: spacings.large,
    },
    info: {
        marginTop: '227px',
        padding: spacings.base,
    },
    columns: {
        height:'100%', 
        marginLeft: 'auto',
        marginRight: 'auto',
    },
    column: {
        position: 'relative',
        height: '100%',
        display: 'inline-block',
        verticalAlign:'top',
        minHeight: '100px',
        minWidth: '250px',
        width: '50%',
    },
    rightPanel: {
        display: 'flex',
        flexDirection: 'column',
        height: '100%',
    },
    chartContainer: {
        paddingLeft: spacings.small,
        paddingRight: spacings.small,
        paddingTop: spacings.small,
        paddingBottom: spacings.small,
        height: '50%',
        maxHeight: '450px',
        minHeight: '400px',
        marginTop: 'auto',
    },
    chartContainerMobile: {
        paddingLeft: '2px',
        paddingRight: '2px',
        paddingTop: '2px',
        paddingBottom: spacings.small,
        height: '50%',
        maxHeight: '450px',
        minHeight: '400px',
        marginTop: 'auto',
    },
    historyContainer: {
        paddingLeft: spacings.large,
        paddingRight: spacings.large,
        paddingBottom: spacings.large,
        height: '50%',
        marginBottom: 'auto',
        marginTop: spacings.base,
    },
    title: {
        fontSize: fontSizes.h4,
        color: colors.themeBlue,
    },
    average: {
        marginTop: spacings.small,
        marginBottom: spacings.base,
        fontSize: fontSizes.bodyL,
		color: colors.themeDarkerGrey,
        opacity: '0.75',
    },
    table: {
        fontSize: fontSizes.bodyL,
        width: '100%',
        color: '#000',
		lineHeight: '1.5',
    },
    tableDate: {
		padding: '2px',
		color: colors.themeDarkerGrey,
        textAlign: 'left',
        opacity: '0.75',
    },
    tableValue: {
		padding: '2px',
		color: colors.themeDarkerGrey,
        textAlign: 'right',
        opacity: '0.75',
    },
    tableAverage: {
		paddingLeft: '2px',
		paddingRight: '2px',
		paddingTop: '0px',
		paddingBottom: spacings.small,
		color: colors.themeBlue,
        textAlign: 'left',
    },
    yAxis: {
		color: colors.themeDarkerGrey,
        fontSize: fontSizes.body,
        position: 'absolute',
        left: spacings.tiny,
        top: 'calc(50% - 50px)',
        transform: 'rotate(-90deg)',
    },
    yAxisMobile: {
		color: colors.themeDarkerGrey,
        fontSize: fontSizes.body,
        position: 'absolute',
        left: '1px',
        top: 'calc(50% - 50px)',
        transform: 'rotate(-90deg)',
    },
	iconButton: {
		boxShadow: 'none',
		backgroundColor: 'transparent',
		border: 'none',
		fontSize: '24px',
		color: colors.themeBlue,
		width: '28px',
		height: '25px',
		paddingLeft: '0',
		paddingRight: '0',
		marginLeft: spacings.small,
		marginRight: spacings.small,
		position: 'relative',
		top: '4px',
	},
    dateSelectIcon: {
        cursor: 'pointer',
		marginLeft: '0',
		marginRight: '0',
    },
};

const StepsChallenge= ({t,
                        showModal,
                        challenge, 
                        historyData,
                        sevenDayHistoryData,
                        sevenDayHistoryAverage,
                        sevenDayHistoryTotal,
                        chartData,
                        chartDataMobile,
                        enableMobileChartDateIncrease,
                        enableMobileChartDateDecrease,
						onChangeMobileChartDate,
                        chartOptions,
                        mobileChartOptions,
                        error, 
                        canAddSteps,
                        onComplete, 
                        completePending, 
                        userChallenge, 
                        value,
                        startedAt,
                        selectedHistory,
                        today,
                        todayHistory, 
                        cancelDoubleClick,
                        enableDateIncrease,
                        enableDateDecrease,
                        onChangeStartedAt,
                        onChange,
                        onOpenModal,
                        onCloseModal}) => (
    <div style={style.container}>
        <div style={style.content}>
            <div style={style.columns}>
                <div style={style.column} className='stepschallenge-column'>
                    <div style={style.segment}>
                        <Grid style={style.grid} centered columns={1}>
                            <Grid.Row verticalAlign='middle'>
                                <Grid.Column verticalAlign='middle' textAlign='center'>
                                    <div style={{...style.title, marginTop: spacings.small}}>{moment(today).format('dddd, MMM DD')}</div>
                                    <div style={style.body}>
                                        <Ring style={style.ring} 
                                                completeFactor={todayHistory.actionsCompleted/challenge.actionsMax} 
                                                color0={colors.themeTeal}
                                                opacity0={1}
                                                color1={colors.themeBlue}
                                                opacity1={1}
                                                width="240px" 
                                                height="240px" 
                                                r0="0.95"
                                                innerCirclePercent="90"
                                                innerCircle2Percent="85"/>
                                        <div style={style.ringContent}>
                                            <Icon style={style.stepIcon} className="icon-aerobics" />
                                            <div style={style.todayValue}>
                                                {numbro(todayHistory.actionsCompleted).format({trimMantissa: true, mantissa: 1, thousandSeparated: true})}
                                                <div style={style.denominator}>
                                                {'/ ' + numbro(challenge.actionsMax).format({trimMantissa: true, mantissa: 1, thousandSeparated: true})}
                                                </div>
                                            </div>
                                        </div>
                                        <div style={style.info}>
                                            <div style={style.points}>
                                                <Icon name="star" /> 
                                                {todayHistory.points}
                                                {/*
                                                <Icon style={style.points} className="notClickable icon-Optimollar"/>
                                                {todayHistory.resources}
                                                */}
                                            </div>
                                            <div>{t('Weekly Total')}</div>
                                            <div>{numbro(sevenDayHistoryTotal).format({trimMantissa: true, mantissa: 1, thousandSeparated: true})}</div>
                                        </div>
                                    </div>
                                    {Boolean(todayHistory.actionsCompleted >= challenge.actionsMax) &&
                                      <div style={style.message}>{t('Completed')}</div>
                                    }
                                    {error &&
                                    <Message negative>
                                        <Message.Header>Error</Message.Header>
                                        <p>{error}</p>
                                    </Message>
                                    }
                                </Grid.Column>
                            </Grid.Row>
                        </Grid>
                    </div>
                    {!error && canAddSteps &&
                        <div style={style.addSteps} onClick={onOpenModal}>{t('Add Steps')}<Icon style={style.addIcon} className='icon-pencil2' /></div>
                    }
                </div>
                <div style={style.column} className='stepschallenge-column'>
                    <div style={style.segment}>
                        {sevenDayHistoryData.length>0 &&
                            <div style={style.historyContainer}>
                                <div style={style.title}>{t('Past [num] Days', {num:7})}</div>
                                <br />
                                <table style={style.table}>
                                    <tbody>
                                        <tr>
                                            <td style={style.tableAverage}>{t('Average')}</td>
                                            <td style={{...style.tableAverage, textAlign: 'right'}}>{numbro(sevenDayHistoryAverage).format({mantissa: 0, thousandSeparated: true})}</td>
                                        </tr>
									    {sevenDayHistoryData.map(h=>(
                                            <tr key={h.isoDateString}>
                                                <td style={style.tableDate}>{h.date.format('MMM D, YYYY')}</td>
                                                <td style={style.tableValue}>{numbro(h.value).format({trimMantissa: true, mantissa: 1, thousandSeparated: true})}</td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        }
				    </div>
                </div>
            </div>

            <div style={{...style.segment, position: 'relative'}} className='stepschallenge-desktop-graph'>
                {!chartData &&
                    <LoadInline centered vcentered />
                }
                {chartData &&
                    <div style={style.chartContainer}>
                        <div style={style.title}><Icon className="icon-aerobics" />{t('Past [num] Days', {num:30})}</div>
                        <Bar data={chartData} options={chartOptions} />
                        <div style={style.yAxis}>{t('Steps')}</div>
                    </div>
                }
            </div>
            <div style={{...style.segment, position: 'relative'}} className='stepschallenge-mobile-graph'>
                {!chartData &&
                    <LoadInline centered vcentered />
                }
                {chartDataMobile &&
                    <div style={style.chartContainerMobile}>
						<button style={style.iconButton} onClick={()=>enableMobileChartDateDecrease && onChangeMobileChartDate(5)} disabled={!enableMobileChartDateDecrease}>
							<Icon className="icon-chevron-left" style={style.dateSelectIcon}  disabled={!enableMobileChartDateDecrease}/>
						</button>
						{chartDataMobile.dateRange}
						<button style={style.iconButton} onClick={()=>enableMobileChartDateIncrease && onChangeMobileChartDate(-5)} disabled={!enableMobileChartDateIncrease}>
							<Icon className="icon-chevron-right" style={style.dateSelectIcon} disabled={!enableMobileChartDateIncrease}/>
						</button>
                        <br />
                        <br />
                        <Bar data={chartDataMobile} options={mobileChartOptions} />
                        <div style={style.yAxisMobile}>{t('Steps')}</div>
                    </div>
                }
            </div>

        </div>


        {Boolean(showModal) &&
            <StepsChallengeModal value={value}
                                 startedAt={startedAt} 
                                 onChange={onChange}
                                 onClose={onCloseModal} 
                                 onSubmit={onComplete} 
                                 cancelDoubleClick={cancelDoubleClick}
                                 enableDateIncrease={enableDateIncrease}
                                 enableDateDecrease={enableDateDecrease}
                                 onChangeStartedAt={onChangeStartedAt}
                                 selectedHistory={selectedHistory} />
        }

    </div>
);

export default translate('challenges')(StepsChallenge);



// WEBPACK FOOTER //
// ./src/modules/challenges/types/StepsChallenge.js